import { Box } from "@mui/system";
import FilterBar from "../../../components/topBarFilter";
import {
  Alert,
  Autocomplete,
  Button,
  createFilterOptions,
  Divider,
  LinearProgress,
  Snackbar,
  TextField,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import ButtonTime from "../../../components/buttonTime";
import useStyles from "./styles";
import dayjs from "dayjs";
import CircularProgressWithLabel from "../../../components/circularProgressWithLabel";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useTheme } from "@emotion/react";
import { Cached } from "@mui/icons-material";
import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import { getDeviceConfig, getDeviceType } from "../../../utils/deviceConfig";
import useErpsCliente from "../../../components/erp/useErpsCliente";

export default function LayoutDashboardClient() {
  const { apiCliente, controllerDashboard, setControllerDashboard } =
    useOutletContext();
  const theme = useTheme();
  // ERP do cliente logado (grupo econômico com tipos misturados: o padrão da
  // HubSoft). Só textos — os serviços vêm do backend pelo usuário do token.
  const { tipos: tiposErp } = useErpsCliente();
  const erp = tiposErp.includes("HUBSOFT") ? "HUBSOFT" : tiposErp[0] || "";
  const labelErp =
    erp === "HUBSOFT"
      ? "Serviço"
      : erp === "VOALLE"
        ? "Contrato"
        : erp === "IXC"
          ? "Contrato"
          : erp === "VERO"
            ? "Contrato"
            : "Serviço";
  const styles = useStyles(theme);
  const cronometroRef = useRef(null);
  const filter = createFilterOptions();
  const [allInterfaces, setAllInterfaces] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isValidRange, setIsValidRange] = useState(false);
  const [propsLayout, setPropsLayout] = useState({
    optionsTime: null, //opções de tempo
    rangeDataTime: null, //intervalo de tempo do dataPicker
    rangeDays: null, // Numero de dias maximo para qualquer range
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const open = Boolean(anchorEl);

  const [allHostsCliente, setAllHostsCliente] = useState([]);
  const [hostsOptions, setHostsOptions] = useState([]);
  const [selectedHostOption, setSelectedHostOption] = useState(null);
  const location = useLocation();
  const [servicesOptionsByCategory, setServicesOptionsByCategory] = useState(
    {},
  );

  const [storageFilterData, setStorageFilterData] = useState(null);
  const [allServicesCliente, setAllServiceCliente] = useState([]);
  const [servicesWithConfig, setServicesWithConfig] = useState([]);
  const [deviceConfig, setDeviceConfig] = useState({});
  //loading #########################################3#####
  const [loading, setLoading] = useState(false); // buttonTIme
  const [loadingHost, setLoadingHost] = useState(false);
  const [loadingInterface, setLoadingInterface] = useState(false);
  const [loadingClient, setLoadingClient] = useState(false);
  const [loadingCronometro, setLoadingCronometro] = useState(false);
  const [loadingService, setLoadingService] = useState(false);

  const [snackbar, setSnackbar] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  //CONTADOR DE CRONOMETRO E VERIFICADOR DE FILTRO
  const [counter, setCounter] = useState(null);
  //TEMPO SELECIONADO E FILTRO ################################################
  const [selectTime, setSelectTime] = useState(5);
  const [filterData, setFilterData] = useState({
    clienteId: "",
    serviceId: "",
    interfaceId: "",
    hostId: "",
    device: "",
    initialDate: dayjs()
      .subtract(30, "minute")
      .set("second", 0)
      .set("millisecond", 0)
      .toDate(),
    finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
  });

  const configErp = (invertInfo) => {
    switch (erp) {
      case "HUBSOFT":
        return {
          labelRef: invertInfo ? "Serviço" : "Referência",
        };
        break;
      case "IXC":
        return {
          labelRef: invertInfo ? "Contrato" : "Descrição auxiliar",
        };
        break;
      default:
        return {
          labelRef: "",
        };
        break;
    }
  };

  useEffect(() => {
    if (!propsLayout?.rangeDays) return;

    const { initialDate, finalDate } = filterData || {};

    if (!initialDate || !finalDate) return;

    const diffInDays = dayjs(finalDate).diff(
      dayjs(initialDate),
      "day",
      true, // considera frações de dia
    );

    if (diffInDays > propsLayout?.rangeDays) {
      handleSelectTime(5);
    }
  }, [
    window.location.pathname,
    filterData?.initialDate,
    filterData?.finalDate,
    propsLayout,
  ]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Sem switch pelo ERP: o backend resolve o cliente (e o ERP dele; grupo
    // econômico, cada membro no seu) pelo usuário do token. CNPJ e código vão
    // só como conferência.
    const cliente = JSON.parse(localStorage.getItem("userCliente"));
    if (cliente) {
      getServicesCliente(
        cliente?.usuarioCliente?.cliente?.cnpj || null,
        cliente?.usuarioCliente?.cliente?.clienteErpId || null,
      );
    }
  }, []);

  useEffect(() => {
    hostFilter();
  }, [window.location.pathname, allHostsCliente]);

  useEffect(() => {
    if (filterData?.hostId) {
      const config = getDeviceConfig(filterData?.device);
      setDeviceConfig(config);
    }
  }, [filterData?.hostId, filterData?.device]);

  useEffect(() => {
    if (selectedHostOption) {
      getInterface();
    }
  }, [selectedHostOption]);

  useEffect(() => {
    if (counter === 60) {
      handleSelectTime(selectTime);
    }
  }, [counter]);

  useEffect(() => {
    if (filterData?.serviceId) {
      localStorage.removeItem("filterDataClient");
      setStorageFilterData(null);
      setAllHostsCliente(null);
      setHostsOptions([]);
      getHostsClient();
    }
  }, [filterData?.serviceId]);

  useEffect(() => {
    const now = dayjs();
    setIsValidRange(
      dayjs.isDayjs(startDate) &&
        dayjs.isDayjs(endDate) &&
        startDate.isValid() &&
        endDate.isValid() &&
        !startDate.isAfter(endDate) &&
        !endDate.isBefore(startDate) &&
        !startDate.isAfter(now) &&
        !endDate.isAfter(now) &&
        (propsLayout?.rangeDays //Caso esteja no easyflow, permitir range maximo de 7 dias
          ? startDate && endDate
            ? dayjs(endDate).isSameOrBefore(
                dayjs.min(
                  dayjs(startDate).add(propsLayout?.rangeDays, "day"),
                  dayjs(),
                ),
              )
            : false
          : true),
    );
  }, [endDate, startDate]);

  const firstDeviceLoaded = useRef(false);
  useEffect(() => {
    if (
      filterData?.finalDate &&
      filterData?.initialDate &&
      filterData?.interfaceId &&
      filterData?.serviceId &&
      filterData?.hostId
    ) {
      const storedFilterData = localStorage.getItem(
        "filterDataClientFromHomeNavigation",
      );
      const parsedFilterData = JSON.parse(storedFilterData);

      if (!firstDeviceLoaded.current && !!parsedFilterData) {
        firstDeviceLoaded.current = true;

        setFilterData((prev) => ({
          ...parsedFilterData,
          initialDate: parsedFilterData?.initialDate || prev?.initialDate,
          finalDate: parsedFilterData?.finalDate || prev?.finalDate,
        }));

        localStorage.removeItem("filterDataClientFromHomeNavigation");

        return;
      }

      const dataFilterStorage = {
        serviceId: filterData?.serviceId,
        interfaceId: filterData?.interfaceId,
        hostId: filterData?.hostId,
        selectTime: selectTime,
        initialDate: filterData?.initialDate,
        finalDate: filterData?.finalDate,
        device: filterData?.device,
        //identificadores do schema
        fabricante: filterData?.fabricante,
        funcao: filterData?.funcao,
        modelo: filterData?.modelo,
      };

      localStorage.setItem(
        "filterDataClient",
        JSON.stringify(dataFilterStorage),
      );
    }
  }, [filterData]);

  const getServicesCliente = async (cnpj, clienteErpId) => {
    if (controllerDashboard) {
      controllerDashboard.abort();
      setAllHostsCliente(null);
      setHostsOptions([]);
      setAllInterfaces([]);
      setAllServiceCliente([]);
    }
    const filterDataStorage = JSON.parse(
      localStorage.getItem("filterDataClient"),
    );

    setStorageFilterData(filterDataStorage);
    if (filterDataStorage?.selectTime || filterDataStorage?.selectTime === 0) {
      setSelectTime(filterDataStorage?.selectTime);
    } else if (filterDataStorage?.initialDate && filterDataStorage?.finalDate) {
      setSelectTime(null);
      setStartDate(dayjs(filterDataStorage?.initialDate));
      setEndDate(dayjs(filterDataStorage?.finalDate));
      setFilterData((prev) => ({
        ...prev,
        initialDate: filterDataStorage?.initialDate,
        finalDate: filterDataStorage?.finalDate,
      }));
    }

    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    setLoadingService(true);
    try {
      const response = await apiCliente.post(
        "/cliente/find/allServiceClient",
        {
          cnpj: cnpj,
          idClienteErp: clienteErpId,
        },
        {
          signal,
        },
      );

      setAllServiceCliente(response?.data || []);

      if (!filterDataStorage) {
        setFilterData((prev) => ({
          ...prev,
          serviceId: response?.data?.[0]?.id_cliente_servico?.toString(),
        }));
      } else {
        setFilterData((prev) => ({
          ...prev,
          serviceId: filterDataStorage?.serviceId?.toString(),
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingService(false);
    }
  };

  const getHostsClient = async () => {
    if (controllerDashboard) {
      controllerDashboard.abort();
      setAllHostsCliente(null);
      setHostsOptions([]);
      setAllInterfaces([]);
      setServicesWithConfig([]);
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    setLoadingHost(true);

    try {
      const response = await apiCliente.post(
        "/cliente/findMany/hosts",
        { includeEmptyHosts: true, mapHostsByServiceAndEquipmentType: true },
        {
          signal,
        },
      );

      const data = response?.data || {};
      setAllHostsCliente(data);
      setServicesWithConfig([
        ...new Set(
          Object.values(data).flatMap((obj) => Object.keys(obj || {})),
        ),
      ]);

      // Mapear os ids dos hosts por tipo
      const getIdsForType = (type) =>
        new Set(
          Object.entries(data[type] || {})
            .filter(([, hosts]) => hosts && hosts.length > 0)
            .map(([id]) => String(id)),
        );

      const cpeIds = getIdsForType("cpes");
      const onuIds = getIdsForType("onus");
      const linkIds = new Set([
        ...getIdsForType("links"),
        ...getIdsForType("sessions"),
      ]);
      const sfpIds = new Set(
        Object.entries(data["cpes"] || {})
          .filter(([, hosts]) =>
            hosts?.some(
              (h) => h?.device === "datacom" || h?.fabricante === "DATACOM",
            ),
          )
          .map(([id]) => String(id)),
      );
      // após filterData.serviceId ser definido(getServicesCliente)
      setServicesOptionsByCategory((prev) => ({
        ...prev,
        cpe: (allServicesCliente || []).filter((s) =>
          cpeIds.has(String(s?.id_cliente_servico)),
        ),
        sfp: (allServicesCliente || []).filter((s) =>
          sfpIds.has(String(s?.id_cliente_servico)),
        ),
        onu: (allServicesCliente || []).filter((s) =>
          onuIds.has(String(s?.id_cliente_servico)),
        ),
        linkAndSession: (allServicesCliente || []).filter((s) =>
          linkIds.has(String(s?.id_cliente_servico)),
        ),
      }));
    } catch (error) {
      console.error("Error fetching hosts:", error);
    } finally {
      setLoadingHost(false);
    }
  };

  const filteredServicesOptions = useMemo(() => {
    const p = location.pathname;
    let options = [];
    if (p.includes("/dash/sfp")) options = servicesOptionsByCategory.sfp || [];
    else if (
      [
        "/home/overview",
        "/home/saude",
        "/home/disponibilidade",
        "/home/firewall",
      ].some((pp) => p.includes(pp))
    )
      options = servicesOptionsByCategory.cpe || [];
    else if (p.includes("/home/onu"))
      options = servicesOptionsByCategory.onu || [];
    else if (p.includes("/home/rede"))
      options = servicesOptionsByCategory.linkAndSession || [];

    // Grupo econômico: MUI groupBy exige as options ordenadas pelo grupo
    if (options.some((service) => service?.ownerNome)) {
      options = [...options].sort((a, b) =>
        (a?.ownerNome || "").localeCompare(b?.ownerNome || ""),
      );
    }

    return options;
  }, [servicesOptionsByCategory, location.pathname]);

  useEffect(() => {
    const p = location.pathname;
    const isKnownFilteredPage =
      p.includes("/dash/sfp") ||
      [
        "/home/overview",
        "/home/saude",
        "/home/disponibilidade",
        "/home/onu",
        "/home/rede",
        "/home/firewall",
      ].some((pagePath) => p.includes(pagePath));

    if (!isKnownFilteredPage) return;

    if (!loadingHost && !loadingService && allServicesCliente?.length > 0) {
      setFilterData((prev) => {
        const currentServiceId = prev?.serviceId?.toString();

        if (filteredServicesOptions.length > 0) {
          const isCurrentServiceValid = filteredServicesOptions.some(
            (service) =>
              service?.id_cliente_servico?.toString() === currentServiceId,
          );

          if (!isCurrentServiceValid) {
            return {
              ...prev,
              serviceId:
                filteredServicesOptions[0]?.id_cliente_servico?.toString() ||
                "",
              hostId: "",
              interfaceId: "",
            };
          }
        } else {
          if (currentServiceId !== "") {
            return {
              ...prev,
              serviceId: "",
              hostId: "",
              interfaceId: "",
            };
          }
        }
        return prev;
      });
    }
  }, [
    filteredServicesOptions,
    loadingHost,
    loadingService,
    allServicesCliente,
    location.pathname,
  ]);

  function hostFilter() {
    if (!allHostsCliente) return;
    const path = {
      cpe: [
        "/home/overview",
        "/home/saude",
        "/home/disponibilidade",
        "/home/dash/sfp",
        "/home/firewall",
      ],
      onu: ["/home/onu"],
      linkAndSession: ["/home/rede"],
    };

    const currentPath = window.location.pathname;
    // Filtrar hosts
    let filteredHosts = [];
    if (path?.cpe?.some((path) => currentPath?.includes(path))) {
      // Se for CPE
      filteredHosts = allHostsCliente?.["cpes"]?.[filterData?.serviceId] || [];
    } else if (path?.onu?.some((path) => currentPath?.includes(path))) {
      // Se for ONU
      filteredHosts = allHostsCliente?.["onus"]?.[filterData?.serviceId] || [];
    } else if (
      path?.linkAndSession?.some((path) => currentPath?.includes(path))
    ) {
      // Se for Link e Session
      filteredHosts = [
        ...(allHostsCliente?.["links"]?.[filterData?.serviceId] || []),
        ...(allHostsCliente?.["sessions"]?.[filterData?.serviceId] || []),
      ];
      // Deduplicate by hostId
      filteredHosts = Array.from(
        new Map(filteredHosts.map((item) => [item?.hostId, item])).values(),
      );
    }
    // Atualizar as opções de filtro
    setHostsOptions(filteredHosts);
    // Selecionar o host armazenado no local storage ou o primeiro host
    const filterDataStorage = JSON.parse(
      localStorage.getItem("filterDataClient"),
    );
    if (
      !!filterDataStorage &&
      !!filterDataStorage?.hostId &&
      filteredHosts?.some(
        (host) =>
          parseInt(host?.hostId) === parseInt(filterDataStorage?.hostId),
      )
    ) {
      setFilterData((prev) => ({
        ...prev,
        hostId: filterDataStorage?.hostId,
        device: filterDataStorage?.device,
        //identificadores do schema
        fabricante: filterDataStorage?.fabricante,
        funcao: filterDataStorage?.funcao,
        modelo: filterDataStorage?.modelo,
      }));
      setSelectedHostOption(
        filteredHosts?.find(
          (host) =>
            parseInt(host?.hostId) === parseInt(filterDataStorage?.hostId),
        ),
      );
    } else {
      setFilterData((prev) => ({
        ...prev,
        hostId:
          filteredHosts?.[0]?.hostid || filteredHosts?.[0]?.hostId || null,
        device: filteredHosts?.[0]?.device || null,
        //identificadores do schema
        fabricante: filteredHosts?.[0]?.fabricante || null,
        funcao: filteredHosts?.[0]?.funcao || null,
        modelo: filteredHosts?.[0]?.modelo || null,
      }));
      setSelectedHostOption(filteredHosts?.[0]);
    }
  }

  const getInterface = async () => {
    if (controllerDashboard) {
      controllerDashboard.abort();
      setAllInterfaces([]);
    }

    // Se algum selectedHostOption?.groups?.name contem "ICMP"
    const isIcmpGroup = selectedHostOption?.groups?.some((group) =>
      group?.name?.includes("ICMP"),
    );

    if (!!isIcmpGroup) {
      setAllInterfaces([]);
      setFilterData((prev) => ({
        ...prev,
        interfaceId: "ICMP",
      }));
      return;
    }

    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    setLoadingInterface(true);
    setAllInterfaces([]);

    try {
      let response;

      if (selectedHostOption?.host?.startsWith("OLT")) {
        const onuList = hostsOptions
          ?.map((host) => host?.onuItem)
          ?.filter((obj) => obj);

        setAllInterfaces(onuList || []);
        response = { data: onuList || [] };
      } else {
        response = await apiCliente.post(
          "/cliente/findMany/interfaces",
          {
            hostId:
              selectedHostOption?.hostid ||
              selectedHostOption?.hostId ||
              filterData?.hostId,
          },
          { signal },
        );
        setAllInterfaces(response?.data || []);
      }

      const filterDataStorage =
        JSON.parse(localStorage.getItem("filterDataClient")) ||
        storageFilterData;
      const savedExternalInterfaceId = filterDataStorage?.interfaceId;
      const isSavedExternalValid =
        !!savedExternalInterfaceId &&
        response?.data?.some((item) => item?.name === savedExternalInterfaceId);

      if (isSavedExternalValid) {
        setFilterData((prev) => ({
          ...prev,
          interfaceId: savedExternalInterfaceId,
        }));
      } else {
        if (selectedHostOption?.host?.startsWith("OLT")) {
          setFilterData((prev) => ({
            ...prev,
            interfaceId: selectedHostOption?.onuItem || "",
          }));
        } else {
          const validHostInterface =
            selectedHostOption?.hostsClienteInterfaces?.find((hostInterface) =>
              response?.data?.some(
                (dataItem) => dataItem?.name === hostInterface,
              ),
            );

          setFilterData((prev) => ({
            ...prev,
            interfaceId:
              validHostInterface ||
              selectedHostOption?.hostsClienteInterfaces?.[0] ||
              response?.data?.[0]?.name,
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching interfaces:", error);
    } finally {
      setLoadingInterface(false);
      setStorageFilterData(null);
    }
  };
  const handleSelectTime = (key) => {
    setSelectTime(key);
    setStartDate(null);
    setEndDate(null);
    handleClose();

    setFilterData((prev) => ({
      ...prev,
      initialDate: optionsTime[key]?.value,
      finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
    }));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStartChange = (newValue) => {
    setStartDate(newValue);
    if (newValue?.isAfter(endDate)) {
      setEndDate(newValue);
    }
  };
  const handleEndChange = (newValue) => {
    setEndDate(newValue);
  };
  const handleAplicar = () => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate).toDate(),
      finalDate: dayjs(endDate).toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };

  const handleAplicarZoom = (startDate, endDate) => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate).toDate(),
      finalDate: dayjs(endDate).toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };

  const startCronometro = (dateInitial, finalDate) => {
    if (selectTime || selectTime === 0) {
      if (cronometroRef.current) {
        clearInterval(cronometroRef.current);
      }
      setCounter(0);
      cronometroRef.current = setInterval(() => {
        setCounter((prev) => {
          if (prev >= 60) {
            return 0;
          } else {
            return prev + 1;
          }
        });
      }, 1000);
    } else {
      setCounter(0);
      clearInterval(cronometroRef.current);
    }
  };
  const stopCronometro = () => {
    clearInterval(cronometroRef.current);
    cronometroRef.current = null;
  };
  const toggleDrawer = (newOpen) => () => {
    setOpenFilter(newOpen);
  };

  const optionsTime = {
    0: {
      value: dayjs()
        .subtract(5, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 5 minutos",
    },
    1: {
      value: dayjs()
        .subtract(15, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 15 minutos",
    },
    2: {
      value: dayjs()
        .subtract(30, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 minutos",
    },
    3: {
      value: dayjs()
        .subtract(1, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Última hora",
    },
    4: {
      value: dayjs()
        .subtract(3, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 3 horas",
    },
    5: {
      value: dayjs()
        .subtract(6, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 6 horas",
    },
    6: {
      value: dayjs()
        .subtract(12, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 12 horas",
    },
    7: {
      value: dayjs()
        .subtract(24, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 24 horas",
    },
    8: {
      value: dayjs()
        .subtract(2, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 2 dias",
    },
    9: {
      value: dayjs()
        .subtract(7, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 7 dias",
    },
    10: {
      value: dayjs()
        .subtract(30, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 dias",
    },
    11: {
      value: dayjs()
        .subtract(90, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 90 dias",
    },
    12: {
      value: dayjs()
        .subtract(6, "month")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 6 meses",
    },
  };
  const actions = [
    {
      icon: <FilterAltOutlinedIcon />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    ...(selectTime || selectTime === 0
      ? [
          {
            icon: <Cached />,
            name: "Atualizar",
            onClick: () => handleSelectTime(selectTime),
          },
        ]
      : []),
  ];

  return (
    <>
      <FilterBar
        actions={actions}
        selectorComponentLeft={
          <Box
            sx={{
              display: "flex",
              gap: 1,
              "@media (max-width:1349px)": {
                flexDirection: "column",
              },
              width: "100%",
            }}
          >
            <Box
              sx={{
                ...styles.autocompleteFilter,
                display: window.location.pathname.includes("/home/flow")
                  ? "none"
                  : "block",
              }}
            >
              <Autocomplete
                disabled={loadingService}
                id="free-solo-demo"
                freeSolo
                size="small"
                options={filteredServicesOptions || []}
                groupBy={
                  filteredServicesOptions?.some((service) => service?.ownerNome)
                    ? (option) => option?.ownerNome || ""
                    : undefined
                }
                value={
                  (Array.isArray(allServicesCliente) &&
                    allServicesCliente?.find(
                      (service) =>
                        service?.id_cliente_servico?.toString() ===
                        filterData?.serviceId?.toString(),
                    )) ||
                  ""
                }
                getOptionLabel={(option) =>
                  option
                    ? `${option?.id_cliente_servico} - ${option?.nome}`
                    : ""
                }
                onChange={(event, value) => {
                  localStorage.removeItem("filterDataClient");
                  clearInterval(cronometroRef.current);
                  setCounter(null);
                  setFilterData((prev) => ({
                    ...prev,
                    serviceId: value?.id_cliente_servico?.toString() || "",
                    interfaceId: "",
                    hostId: "",
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    sx={{
                      fontSize: "0.75rem", // diminui fonte geral
                    }}
                    {...params}
                    label={labelErp}
                  />
                )}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  // Se a pesquisa normal não encontrar nada, ou se você quiser forçar a busca em outros campos:
                  return options.filter(
                    (option) =>
                      option.nome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.id_cliente_servico
                        ?.toString()
                        .includes(params.inputValue) ||
                      option.referencia
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.ownerNome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()),
                  );
                }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;

                  // Se não houver referência, renderiza o formato simples (padrão)
                  if (!option.referencia) {
                    return (
                      <li key={key} {...optionProps}>
                        {`${option.id_cliente_servico} - ${option.nome}`}
                      </li>
                    );
                  }

                  // Se houver referência, renderiza o formato personalizado
                  return (
                    <li key={key} {...optionProps}>
                      <Box sx={styles.boxLine}>
                        <span style={{ fontWeight: "bold" }}>
                          {`${option.id_cliente_servico} - ${option.nome}`}
                        </span>
                        {option.referencia?.trim() && (
                          <>
                            <Divider sx={{ margin: "2px 0" }} />
                            <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                              <span style={{ fontWeight: "bold" }}>
                                {configErp(option?.invertInfo).labelRef}:
                              </span>{" "}
                              {option.referencia}
                            </span>
                          </>
                        )}
                      </Box>
                    </li>
                  );
                }}
              />
              {loadingService && <LinearProgress />}
            </Box>
            <Box
              sx={{
                ...styles.autocompleteFilter,
                display:
                  window.location.pathname.includes("/home/flow") ||
                  (hostsOptions || []).length <= 1
                    ? "none"
                    : "block",
              }}
            >
              <Autocomplete
                loading={loadingHost}
                disabled={loadingHost || !filterData?.serviceId}
                id="host-autocomplete"
                size="small"
                options={hostsOptions || []}
                value={selectedHostOption}
                getOptionLabel={(option) => option?.host || ""}
                // Valida a correspondência do host considerando variações de chaves de identificação
                isOptionEqualToValue={(option, value) => {
                  const optId = option?.hostId || option?.hostid || option?.id;
                  const valId = value?.hostId || value?.hostid || value?.id;
                  return Boolean(
                    optId && valId && String(optId) === String(valId),
                  );
                }}
                onChange={(event, value) => {
                  if (cronometroRef.current)
                    clearInterval(cronometroRef.current);
                  if (setCounter) setCounter(null);
                  setSelectedHostOption(value);
                  setFilterData((prev) => ({
                    ...prev,
                    hostId: value?.hostId || "",
                    device: value?.device,
                    interfaceId: "",
                    fabricante: value?.fabricante || null,
                    funcao: value?.funcao || null,
                    modelo: value?.modelo || null,
                  }));
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Host" />
                )}
              />
              {loadingHost && !loadingClient && <LinearProgress />}
            </Box>
            <Box
              sx={{
                ...styles.autocompleteFilter,
                display:
                  window.location.pathname.includes("/home/rede") ||
                  window.location.pathname.includes("/home/flow") ||
                  window.location.pathname.includes("/home/firewall") ||
                  selectedHostOption?.groups?.some((group) =>
                    group?.name?.includes("ICMP"),
                  )
                    ? "none"
                    : "block",
              }}
            >
              <Autocomplete
                disabled={loadingInterface || !filterData?.hostId}
                id="free-solo-demo"
                freeSolo
                size="small"
                options={allInterfaces?.filter((option) => {
                  if (option === null || option === undefined) return false;
                  if (selectedHostOption?.hostsClienteInterfaces?.length > 0) {
                    return selectedHostOption.hostsClienteInterfaces.includes(
                      option?.name,
                    );
                  }

                  return true;
                })}
                isOptionEqualToValue={(option, value) => {
                  const optVal =
                    typeof option === "string" ? option : option?.name;
                  const valVal =
                    typeof value === "string" ? value : value?.name;
                  return optVal === valVal;
                }}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;
                  if (option?.description)
                    return `${option.name} - ${option.description}`;
                  return option?.name || "";
                }}
                value={
                  (typeof filterData?.interfaceId === "string"
                    ? allInterfaces?.find(
                        (opt) => opt?.name === filterData?.interfaceId,
                      ) || filterData?.interfaceId
                    : filterData?.interfaceId) || ""
                }
                onChange={(event, value) => {
                  localStorage.removeItem("filterData");
                  clearInterval(cronometroRef.current);
                  setCounter(null);
                  setFilterData((prev) => ({
                    ...prev,
                    interfaceId: value?.name || value || "",
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    {...params}
                    label={`${deviceConfig?.metaData?.ifLabel || "Interface"}`}
                    sx={{
                      fontSize: "0.75rem", // diminui fonte geral
                    }}
                  />
                )}
              />

              {loadingInterface && <LinearProgress />}
            </Box>
          </Box>
        }
        selectorComponentRight={
          <Box sx={{ display: "flex", gap: 1 }}>
            {(counter || counter === 0) &&
            (selectTime || selectTime === 0) &&
            !loadingCronometro &&
            windowWidth >= 1350 ? (
              <CircularProgressWithLabel value={counter} />
            ) : (
              <></>
            )}

            <ButtonTime
              open={open}
              optionsTime={propsLayout?.optionsTime || optionsTime}
              selectTime={selectTime}
              handleClick={handleClick}
              anchorEl={anchorEl}
              handleClose={handleClose}
              loading={loading}
              handleStartChange={handleStartChange}
              handleEndChange={handleEndChange}
              handleAplicar={handleAplicar}
              isValidRange={isValidRange}
              endDate={endDate}
              startDate={startDate}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              setSelectTime={setSelectTime}
              handleSelectTime={handleSelectTime}
              filterData={filterData}
              DateTime={DateTimePicker}
              todayMaxDataTime={
                propsLayout?.rangeDays
                  ? startDate
                    ? dayjs.min(
                        dayjs(startDate).add(propsLayout?.rangeDays, "day"),
                        dayjs(),
                      )
                    : null
                  : null
              }
            />

            {(selectTime || selectTime === 0 || loadingCronometro) &&
            windowWidth >= 1350 ? (
              <Button
                size="small"
                variant="outlined"
                disabled={loadingCronometro}
                onClick={() => handleSelectTime(selectTime)}
                sx={{
                  ...styles.buttonRefresh,
                  "& .rotating": {
                    animation: "spin 1s linear infinite",
                  },
                  "@keyframes spin": {
                    "0%": {
                      transform: "rotate(0deg)",
                    },
                    "100%": {
                      transform: "rotate(-360deg)",
                    },
                  },
                }}
              >
                <Cached
                  fontSize="small"
                  sx={{ color: theme.palette.text.main }}
                  className={loadingCronometro ? "rotating" : ""}
                />
              </Button>
            ) : (
              <></>
            )}
          </Box>
        }
        windowWidth={30000}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={1}
      />
      <Box component="main">
        <Box>
          <Outlet
            context={{
              filterData,
              handleAplicarZoom,
              setCounter,
              setLoadingCronometro,
              selectTime,
              optionsTime,
              startCronometro,
              controllerDashboard,
              setControllerDashboard,
              toggleDrawer,
              apiCliente,
              api: apiCliente,
              stopCronometro,
              deviceConfig,
              setPropsLayout,
            }}
          />
        </Box>
      </Box>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </>
  );
}
